export default "__VITE_ASSET__6d812750__"